import { ActivatedFacets, Facet } from "../../../components/_shared-components/generic-listing-page/types";

export function getFullActiveFacets(activatedFacets: ActivatedFacets, facets: Array<Facet>) {
  return Object.entries(activatedFacets).flatMap(([activeFacetKey, activeFacetValue]) => {
    const activeFacetWithLabel = facets.find(
      f =>
        f.__key === activeFacetKey &&
        activeFacetValue &&
        f.values.map(v => v.value.toString()).includes(activeFacetValue.toString()),
    );

    const valueLabel =
      activeFacetValue &&
      activeFacetWithLabel?.values.find(v => v.value.toString() === activeFacetValue.toString())?.label;

    if (activeFacetValue && activeFacetWithLabel && valueLabel) {
      return [
        { key: activeFacetKey, value: activeFacetValue, keyLabel: activeFacetWithLabel.label, valueLabel: valueLabel },
      ];
    } else {
      // console.log(`This should never happen.`);
      return [];
    }
  });
}
